import { SchoolClass } from 'src/app/templates/models/schoolClass.interface';
import { Stage } from 'src/app/templates/models/stage.interface';

export class StageSelectionClass {
  constructor() {
    this.stages = [];
    this.classes = [];
  }
  stages: Stage[];
  classes: SchoolClass[];
  isStageEnabled?: boolean;
}
